export default "__VITE_ASSET__BPud2Tcx__"